import React,{useEffect,useState} from 'react'
import styles from './myServiceRequest.module.css';
import IMAGES from '../../../../assets/images/images';
import { Link, useNavigate } from 'react-router-dom';
import InfiniteScroll from "react-infinite-scroll-component";
import { Loader } from "../../../../components/loader/Loader";
import moment from 'moment';
import { filterAndMapIds, formatDate, futureDate,formatDateDDMMM,computeWeightedWidths} from '../../../../utils/arrayUtils';
import { MY_INCIDENT_TABS, serviceReqColumnConfig, STATUS_ENUM } from '../../../../utils/constants/incidentConstants';
import { USER_TYPE } from '../../../../utils/constants/userConstants';
import Table from '../../../../components/table/Table';
import SecondaryTooltip from '../../../../components/secondaryToolTip/secondaryToolTip';
import Status from '../../../../components/status/Status';
import { allCount, checkAllFalse } from '../../../../utils/utils';
import CAN from '../../../../casl/can';
import { Action, Resource } from '../../../../casl/constants';
import MissingCustomerlist from '../../../../components/missingCustomerList/MissingCustomerList';
import SectionGuard from '../../../../hoc/guards/SectionGuard';
import { AppliedFilter, Filter } from '../../../../components/filter/filter';
import { COLUMN_KEYS, FILTER_KEYS } from '../../../../utils/constants/userManagementConstant';
import { Search } from "../../../../components/search/search";

const SearchBar = ({ setSearchKeyValue,setIsQuickSearch, searchKeyValue}) => {
  const inputStyle = `${styles.inputContainer} `;

  const filterByQuickSearch=(value)=>{
    setSearchKeyValue(value)
    setIsQuickSearch(true);
  }
  
  return (
       <div className={styles.searchContainer}>
          <Search
           placeholder={"Search by Ticket ID"}
           style={inputStyle}
           onButtonClick={filterByQuickSearch}
           searchKeyValue={searchKeyValue}
          />        
        </div> 
  );
};

const ServiceRequestViewer = (props) => {
  let [searchKeyValue, setSearchKeyValue] = useState('');
  const [isQuickSearch, setIsQuickSearch] = useState(false);
  const navigate = useNavigate();
  const data = props.serviceList.data;
  const [filterState, setFilterState] = useState({isOrgnameFilter: false,selectedOrgNameOptions: props?.columnFilters?.orgName||[]});
   // oneitsm_api_integration :  Removed need_more_information and resolved  status
  // oneitsm_api_integration :  Added cancelled status
  const statuses = [
    { id: 'all', label: 'All', count: allCount(props?.statusCount), className: 'statusAll',color: '#CCCCCC',outline:"#9E9E9E" },
    { id: 'new', label: 'New', count: props?.statusCount?.new?props?.statusCount?.new:0,color: '#FFF1BB',infoMessage : "New",outline:"#F4D55B" },
    { id: 'in_progress', label: 'In Progress', count: props?.statusCount?.in_progress?props?.statusCount?.in_progress:0, color: '#FFE1AB', infoMessage: "In Progress",outline:"#F4B035" },
    // { id: 'need_more_information', label: 'Need More Information', count: props?.statusCount?.need_more_information?props?.statusCount?.need_more_information:0, color: '#D5F9FF', infoMessage: "Need More Information",outline:"#89DBE9" },
    { id: 'customer_feedback_awaited', label: 'Customer Feedback Awaited', count: props?.statusCount?.customer_feedback_awaited?props?.statusCount?.customer_feedback_awaited:0, color: '#EEECFF', infoMessage: "Customer Feedback Awaited",outline:"#9188E0" },
    // { id: 'resolved', label: 'Resolved', count: props?.statusCount?.resolved?props?.statusCount?.resolved:0, color: '#C7FFE6', infoMessage: "Resolved",outline:"#80D8B0" },
    { id: 'closed', label: 'Closed', count: props?.statusCount?.closed?props?.statusCount?.closed:0, color: '#E8E8E8', infoMessage: "Closed",outline:"#C2C2C2" },
    { id: 'cancelled', label: 'Cancelled', count: props?.statusCount?.cancelled?props?.statusCount?.cancelled:0, color: '#FFE1E4', infoMessage: "Cancelled",outline:"#E64040" },

  ];
  const defaultStatuses = statuses.reduce((acc, status) => ({ ...acc, [status.id]: true }),{});
  const checkedStatuses = props.statusFilter || defaultStatuses;
  // const [checkedStatuses, setCheckedStatuses] = useState(statuses.reduce((acc, status) => ({ ...acc, [status.id]: true }), {}));
  const [sortOrder, setSortOrder] = useState("desc");
  const handleStatusChange = (newCheckedStatuses) => {
    // setCheckedStatuses(newCheckedStatuses);
    props.setStatusFilter(FILTER_KEYS.SERVICEREQUEST,newCheckedStatuses);
  };
  const toggleSortOrder = () => {
    setSortOrder((prevOrder) => (prevOrder === "desc" ? "asc" : "desc"));
  };
  const resetsecondaryFilter = () => {};
 useEffect(() => {
  if(CAN(Action.LIST,Resource.MISSING_ONEITSM_SERVICE_CUSTOMERS)){
    props.getAllMissingOneItsmCustomers()
  }
  if(props?.myRights?.userType===USER_TYPE.INTERNAL){
    props?.getFilteredCustomers();
  }
  const statusFilter = Object.keys(checkedStatuses)?.filter((key) => checkedStatuses[key]).join(",")
  const uniqueCustomerRefId = filterState.selectedOrgNameOptions.map((item) => item.value).join(",");
  if(!checkAllFalse(checkedStatuses)){
   props.getServiceList(null,statusFilter,uniqueCustomerRefId,sortOrder,searchKeyValue.trim());
  }
  window.scrollTo(0,0);
}, [checkedStatuses,filterState.selectedOrgNameOptions,sortOrder]);

const fetchData = () => {
  if (props.serviceList.next) {
    const statusFilter = Object.keys(checkedStatuses)?.filter((key) => checkedStatuses[key]).join(",")
    const uniqueCustomerRefId = filterState.selectedOrgNameOptions.map((item) => item.value).join(",");
    props.getServiceList(props.serviceList.next,statusFilter,uniqueCustomerRefId,sortOrder,searchKeyValue.trim());
  }
};

const gotoDetail = (requestId,notificationId) => {
  // navigate(`/incident-management/serviceRequestDetail/${requestId}`);
  if(notificationId?.length>0){
    notificationId.forEach(id => {
      const payload = {
        read: true,
      };
      props.ReadNotification(payload, id);
    });
  }
}

const getStatusLegendColorClass = (status) => {
  switch (true) {
    case status === STATUS_ENUM.NEW:
      return "new";
    case status === STATUS_ENUM.PENDING:
      return "pending";
    case status === STATUS_ENUM.IN_PROGRESS:
      return "in_progress";
    case status === STATUS_ENUM.ASSIGNED:
      return "assigned";
    case status === STATUS_ENUM.RESOLVED:
      return "resolved";
    case status === STATUS_ENUM.CLOSED:
      return "closed";
    case status === STATUS_ENUM.NEED_MORE_INFORMATION:
      return "need_more_information";
    case status === STATUS_ENUM.CUSTOMER_FEEDBACK_AWAITED:
      return "customer_feedback_awaited";
    case status === STATUS_ENUM.CANCELLED:
        return "cancelled";
    default:
      return status;
  }
};

const handleOrgNameFilterApply = (selectedOptions) => {
  setSearchKeyValue("")
  setFilterState(prevState => ({
    ...prevState,
    selectedOrgNameOptions: selectedOptions
  }));
  props.setColumnFilters(FILTER_KEYS.SERVICEREQUEST,COLUMN_KEYS.ORG_NAME,selectedOptions);
};

const handleOrgNameFilterReset = () => {
  setFilterState(prevState => ({
    ...prevState,
    isOrgnameFilter:false,
    selectedOrgNameOptions: [],
  }));
};

const resetappliedFilter = () =>{
  handleOrgNameFilterReset();
  props?.resetColumnFilters(FILTER_KEYS.SERVICEREQUEST)
  setIsQuickSearch(false);
}
  useEffect(() => {
    if (isQuickSearch) {
      resetappliedFilter();
    }
  }, [isQuickSearch]);

const headers = props?.myRights?.userType===USER_TYPE.INTERNAL?[
  <div className={styles.organisationName} key="id"><div className={styles.orgname}>Ticket ID</div></div>,
  <div className={styles.organisationName} key="title"><div className={styles.orgname}>Title</div></div>,
<div className={styles.organisationName} key="displayName"><div className={styles.orgname}>Organisation Legal Name</div>
      <img className={`${styles.filter} ${filterState.selectedOrgNameOptions?.length > 0? styles.activeFilter: ""}`} src={IMAGES.filtericon} onClick={() => setFilterState(prevState => ({ ...prevState, isOrgnameFilter: true }))} alt="Filter"/>
      {filterState.isOrgnameFilter && (
      <div className={styles.popup}><Filter isOpen={filterState?.isOrgnameFilter} options={props?.filterCustomers?.data?.map(item => ({ value: item?.uniqueCustomerRefId, label: item?.displayName,type: item?.serviceType}))} type={"serviceType"} onApply={handleOrgNameFilterApply} onRequestClose={() => setFilterState(prevState => ({ ...prevState, isOrgnameFilter: false }))} label={"Organisation Legal Name"} initialSelectedOptions={filterState?.selectedOrgNameOptions} onReset={resetappliedFilter} maxSelectionCount={3}/></div>)}
  </div>,
  // <div className={styles.organisationName} key="oneItsmId"><div className={styles.orgname}>OneITSM ID</div></div>,
  <div className={styles.organisationName} key="customerName"><div className={styles.orgname}>Requestor</div></div>,
  <div className={styles.organisationName} key="serviceType"><div className={styles.orgname}>Service Type</div></div>,
  <div className={styles.organisationName} key="createdOn"><div className={styles.orgname}>Created On</div></div>,
  <div className={styles.organisationName} key="lastUpdatedOn"><div className={styles.orgname}>Last Updated On</div><img className={`${styles.sorting} ${sortOrder==='desc'?styles.desc:styles.asc}`} src={IMAGES.sorticon} onClick={toggleSortOrder} alt="sort"/></div>,
]:[
  <div className={styles.organisationName} key="id"><div className={styles.orgname}>Ticket ID</div></div>,
   <div className={styles.organisationName} key="title"><div className={styles.orgname}>Title</div></div>,
  // <div className={styles.organisationName} key="oneItsmId"><div className={styles.orgname}>OneITSM ID</div></div>,
  <div className={styles.organisationName} key="customerName"><div className={styles.orgname}>Requestor</div></div>,
  <div className={styles.organisationName} key="serviceType"><div className={styles.orgname}>Service Type</div></div>,
  <div className={styles.organisationName} key="createdOn"><div className={styles.orgname}>Created On</div></div>,
  <div className={styles.organisationName} key="lastUpdatedOn"><div className={styles.orgname}>Last Updated On</div><img className={`${styles.sorting} ${sortOrder==='desc'?styles.desc:styles.asc}`} src={IMAGES.sorticon} onClick={toggleSortOrder} alt="sort"/></div>,
];

const mappedData = data?.map((item) => {
  const colorClass = getStatusLegendColorClass(item?.status?.value);
  const match = props.notificationdata?.find(row => row.detailsId === item.id);
  const ids = filterAndMapIds(props.notificationdata, item.id);
  const highlightClass = match ? styles.highlightedRow : '';
  const url = `/incident-management/serviceRequestDetail/${item.id}`;
  return {
    // id: <span className={`${styles.orglgname} ${styles.posrelative} ${match?styles.boldid:""}`}><span className={`${highlightClass}`}></span><SecondaryTooltip text={colorClass?.replace(/_/g, ' ')?.replace(/\b\w/g, char => char?.toUpperCase())} positions={['bottom', 'left']}><span className={`${styles.statusLegendsIcon} ${styles[colorClass]} ${match ? styles.margingleft:""}`} /></SecondaryTooltip><SecondaryTooltip text={match?.message?match.message:item?.serviceRequestId} positions={['bottom', 'right']} ><Link className={styles.srlink} to={url} onClick={()=>gotoDetail(item?.id,ids)}>{item?.serviceRequestId}</Link></SecondaryTooltip></span>,
    id: <span className={`${styles.orglgname} ${styles.posrelative} ${styles.textoverflow} ${match?styles.boldid:""}`}><span className={`${highlightClass}`}></span><SecondaryTooltip text={colorClass?.replace(/_/g, ' ')?.replace(/\b\w/g, char => char?.toUpperCase())} positions={['bottom', 'left']}><span className={`${styles.statusLegendsIcon} ${styles[colorClass]} ${match ? styles.margingleft:""}`} /></SecondaryTooltip><SecondaryTooltip text={match?.message?match.message:item?.ticketIdServiceDesk} positions={['bottom', 'right']} ><Link className={styles.srlink} to={url} onClick={()=>gotoDetail(item?.id,ids)}>{item?.ticketIdServiceDesk}</Link></SecondaryTooltip></span>,
    title: <SecondaryTooltip text={item?.serviceRequestDetails?.title} positions={['bottom', 'right']}><span className={`${styles.customDataContent} ${styles.textoverflow}`}>{item?.serviceRequestDetails?.title}</span></SecondaryTooltip>,
    displayName: <SecondaryTooltip text={item?.displayName?item?.displayName:"---"} positions={['bottom', 'right']}><span className={`${styles.customDataContent} ${styles.textoverflow}`}>{item?.displayName?item.displayName:"---"}</span></SecondaryTooltip>,
    customerName: <SecondaryTooltip text={item?.createdBy?.email} copy={true} positions={['bottom', 'right']}><span className={`${styles.customDataContent} ${styles.textoverflow}`}>{item?.createdBy?.name}</span></SecondaryTooltip>,
    // oneItsmId: <span className={`${styles.customDataContent}`}><SecondaryTooltip text={item?.ticketIdServiceDesk?item?.ticketIdServiceDesk:"---"} positions={['bottom', 'right']}>{item?.ticketIdServiceDesk?item?.ticketIdServiceDesk:"---"}</SecondaryTooltip></span>,
    serviceType: <SecondaryTooltip text={item?.serviceRequestType?.label} positions={['bottom', 'right']}><span className={`${styles.customDataContent} ${styles.textoverflow}`}>{item?.serviceRequestType?.label}</span></SecondaryTooltip>,
    faultType: <SecondaryTooltip text={item?.incidentFaultType?.label} positions={['bottom', 'right']}><span className={`${styles.customDataContent} ${styles.textoverflow}`}>{item?.incidentFaultType?.label}</span></SecondaryTooltip>,
    createdOn: <SecondaryTooltip text={formatDate(item?.createdAt)} positions={['bottom', 'right']}><span className={`${styles.customDataContent} ${styles.textoverflow}`}>{formatDate(item?.createdAt)}</span></SecondaryTooltip>,
    lastUpdatedOn: <div className={styles.modifiedonwrapper}><SecondaryTooltip text={formatDate(item.modifiedAt)} positions={['bottom', 'right']}><span className={`${styles.customDataContent} ${styles.textoverflow}`}>{formatDate(item.modifiedAt)}</span></SecondaryTooltip>
      <span className={styles.parentnoti}>
        {props?.myRights?.userType===USER_TYPE.CUSTOMER &&(
        <>
          {item.status.value===STATUS_ENUM.CUSTOMER_FEEDBACK_AWAITED&&(<SecondaryTooltip text={`This ticket has been resolved. Please confirm or reject the resolution within 2 business days; otherwise, it will be automatically closed.`} positions={['bottom', 'left']} backgroundclr={"#FFEECC"} status={"dueby"}><img className={styles.infocircle} src={IMAGES.infoCircle}/></SecondaryTooltip>)}
          {/* {item.status.value===STATUS_ENUM.CUSTOMER_FEEDBACK_AWAITED&&(<SecondaryTooltip text={`Please respond by ${futureDate(item?.modifiedAt)} to accept or reject the ticket resolution.`} positions={['bottom', 'left']} backgroundclr={"#FFEECC"} status={"dueby"}><img className={styles.infocircle} src={IMAGES.infoCircle}/></SecondaryTooltip>)} */}
          {/* {item.status.value===STATUS_ENUM.NEED_MORE_INFORMATION&&(<SecondaryTooltip text={`Respond by ${futureDate(item?.modifiedAt)}, or the ticket will be auto closed.`} positions={['bottom', 'left']} backgroundclr={"#FFEECC"} status={"dueby"}><img className={styles.infocircle} src={IMAGES.infoCircle}/></SecondaryTooltip>)} */}
        </>)}
        <span className={styles.notificationmain}>{item.isServiceDeskCommentReceived && props?.myRights?.userType===USER_TYPE.CUSTOMER &&(<div className=""><span className={styles.commentnotification}></span> <img className={styles.newcomment}src={IMAGES.newcomment} alt="new comment"/></div>)}</span>
      </span></div>};
});
    return (
      <>
        {props?.myRights?.userType===USER_TYPE.INTERNAL&&props?.missingOneItsmCustomers?.length>0&&(
              <SectionGuard canAccess={CAN(Action.LIST,Resource.MISSING_ONEITSM_SERVICE_CUSTOMERS)}>
                <MissingCustomerlist missingOneItsmCustomers={props?.missingOneItsmCustomers}/>
              </SectionGuard>
        )}
      <div className={styles.wrapperchild}>
        {props.serviceList.isLoading&& (
         <Loader />
        )}
          <InfiniteScroll
           dataLength={props.serviceList.data?.length}
            next={() => {
              if(!checkAllFalse(checkedStatuses)){
                fetchData();
              }
            }}
           hasMore={!checkAllFalse(checkedStatuses) ? props.serviceList.next : null}
           loader={<Loader />}
           >
          <SearchBar setSearchKeyValue={setSearchKeyValue} setIsQuickSearch={setIsQuickSearch} searchKeyValue={searchKeyValue} />    
           <div className={styles.statussection}>
            <Status statuses={statuses} onStatusChange={handleStatusChange} checkedStatuses={checkedStatuses} infoImage={IMAGES.infoCircle} onResetfilter={resetsecondaryFilter} />
           </div>
           {filterState.selectedOrgNameOptions.length > 0&& (<AppliedFilter selectedFilterOptions={filterState?.selectedOrgNameOptions} onReset={resetappliedFilter}setSelectedFilterOptions={setFilterState} handleFilterApply={handleOrgNameFilterApply} firstFilterLabel={"Organisation Legal Name"}/>)}
           <Table headers={headers} data={checkAllFalse(checkedStatuses)?[]:mappedData} height={`${(mappedData?.length<8 ||checkAllFalse(checkedStatuses))&&(filterState?.isOrgnameFilter)?"480px":"auto"}`} width="100%" columnConfig={computeWeightedWidths(serviceReqColumnConfig)} isWidth={true} nodata={!props.serviceList.isLoading&&mappedData?.length===0?"No Data.":"No Data."}/>
          </InfiniteScroll>
      </div>
      </>
    )
}
  
export default ServiceRequestViewer;

